import { render, staticRenderFns } from "./InputAccept.vue?vue&type=template&id=1e377270&"
import script from "./InputAccept.vue?vue&type=script&lang=ts&"
export * from "./InputAccept.vue?vue&type=script&lang=ts&"
import style0 from "./InputAccept.vue?vue&type=style&index=0&id=1e377270&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports